import { makeStyles } from '@material-ui/core'

const TimelineStyle = (theme) => ({
    blackBackground: {
        backgroundColor: theme.palette.primary.main,
    },
    contentWrapper: {
        padding: theme.spacing(1),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        marginTop: 100,
    },
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    paper: {
        padding: '0.5em',
    },
    timeline: {
        // maxWidth: '60%'
    },
    header: {
        minWidth: '40vw',
    },
    fileLink: {
        paddingLeft: '5pt',
    },
})

export default makeStyles(TimelineStyle, { withTheme: true })
